import { render, staticRenderFns } from "./FlutterDevelopment.vue?vue&type=template&id=54b82cf4&"
import script from "./FlutterDevelopment.vue?vue&type=script&lang=js&"
export * from "./FlutterDevelopment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports